export class AppIsSafeToEditUpdateRequest {
	constructor(app, isSafeToEdit, currentUserName) {
		this.App = app;
		this.IsSafeToEdit = isSafeToEdit;
		this.UpdatedBy = currentUserName;
	}
}
